<template>
  <div class="feedback">
    <van-popup :style="{ zIndex:'100000' }" @click-overlay="close" v-model="feedbackVisible">
      <div class="content-box">
        <h2>反馈类型：</h2>
        <div class="selet-item-box">
          <span @click="changeIndex(index)" :key="index" :class="{'active':index === currentIndex}" v-for="(item,index) in list">{{item}}</span>
        </div>
        <h2>问题描述：</h2>
        <textarea v-model="textValue" maxlength="500" class="feedback-input" placeholder="请将您的建议或遇到的问题告诉我们，我们会认真听取并及时反馈" />
        <div class="conut-text">{{textValueLength}} / 500</div>
        <div @click="debounceSubmit" class="feedback-submit" :class="{'disbale': disableSubmit}">提交反馈</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { videoFeedback } from '@/api/learn';
import _ from 'lodash';

export default {
  props: ['visible', 'videoName', 'productName', 'errorMsg'],
  data() {
    return {
      routeParams: null,
      feedbackVisible: this.visible,
      playErrorMsg: this.errorMsg,
      list: ['内容错误', '加载失败', '经常卡顿'],
      currentIndex: 0,
      textValue: null,
      typeList: {
        0: 6,
        1: 7,
        2: 8,
      },
    };
  },
  computed: {
    ...mapState(['userInfo']),
    disableSubmit() {
      return !!this.textValue;
    },
    textValueLength() {
      return this.textValue?.length ?? 0;
    },
  },
  watch: {
    visible() {
      this.feedbackVisible = this.visible;
      this.routeParams = this.$route.params;
    },
    errorMsg() {
      this.playErrorMsg = this.errorMsg;
    },
  },
  mounted() {
    this.routeParams = this.$route.params;
  },
  methods: {
    close() {
      this.textValue = null;
      this.currentIndex = 0;
      this.$emit('feedbackClose');
    },
    changeIndex(index) {
      this.currentIndex = index;
    },
    debounceSubmit() {
      return _.debounce(this.submit, 500)();
    },
    async submit() {
      if (!this.textValue?.length) return;
      // 提交的参数
      const { type } = this.routeParams;
      const { phone, id, nickName } = this.userInfo;
      const isCC = Number(type) === 1; // CC，否则是百家云
      const obj = {
        company: 0, // 所属平台 0 启航 1 云图
        creator: nickName, // 创建人
        equipment: '', // 用户设备
        errorMessage: this.playErrorMsg, // 错误信息
        images: '', // 问题图片路径
        ip: '', // 反馈用户IP
        mobile: phone, // 用户手机号
        playerVersion: '', // 反馈视频播放器版本
        question: this.textValue, // 问题描述
        status: 0, // 状态(新建传 0)：0.未处理 1.已处理 2.已忽略
        systemV: '', // 系统版本
        terminal: 3, // 反馈终端：1.PC；2.APP；3.H5；4.小程序
        terminalV: '', // 版本
        terrace: 1, // 问题来源：1.爱启航；2.集训；3.启航vip
        terraceDetail: 1, // 反馈具体来源: 0 系统默认 1 视频页面反馈
        type: this.typeList[this.currentIndex], // 反馈类型: 1 课程反馈 2 功能反馈 3 课程列表 4 链接 5 课程 6 内容反馈 7 加载失败 8 经常卡顿
        ua: window.userAgent, // 反馈ua信息
        userId: id, // 用户ID
        videoHostName: '', // 反馈主机地址
        videoName: this.videoName, // 反馈视频名称
        videoProductName: this.productName || sessionStorage.getItem('guideProductName'), // 反馈视频产品名称
        videoType: isCC ? 0 : 1, // 反馈视频类型 0:cc 1:百家云
        videoVid: this.routeParams.vid, // 反馈视频vid
      };
      console.log(obj);
      const res = await videoFeedback(obj);
      this.close();
      if (res.code === 0) {
        this.$toast.success('反馈成功');
      } else if (res.code === -1) {
        this.$toast.fail('提交失败，请勿重复操作');
      } else {
        this.$toast.fail(res.msg);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.feedback {
  width: 100%;
  .van-popup.van-popup--center {
    width: 84.5%;
    min-height: 100px;
    background: #FFF;
    border-radius: 7px;
    box-sizing: border-box;
    padding: 5.73%;
    z-index: 10000 !important;
  }
  .content-box{
    width: 100%;
    h2{
      width: 127px;
      height: 36px;
      font-size: 25px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 36px;
      margin-bottom: 22px;
    }
    .selet-item-box{
      width: 468px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      margin-bottom: 51px;
      span{
        width: 138px;
        height: 50px;
        font-size: 25px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 48px;
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        border: 2px solid #FFF;
      }
      span.active {
        width: 138px;
        height: 50px;
        line-height: 48px;
        color: #FF7F41;
        border-radius: 25px;
        text-align: center;
        border: 2px solid #FF7F41;
      }
    }
    .feedback-input {
      width: 100%;
      height: 257px;
      box-sizing: border-box;
      background: #F6F7F9;
      border-radius: 14px;
      padding: 29px;
      font-size: 25px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333;
      line-height: 36px;
      &::-webkit-input-placeholder {
        color: #999;
      }
    }
    .feedback-submit{
      width: 203px;
      height: 67px;
      background: #CCC;
      border-radius: 41px;
      margin: 0 auto;
      margin-top: 51px;
      font-size: 29px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center;
      line-height: 67px;;
    }
    .feedback-submit.disbale {
      background: #FF7F41;
    }
    .conut-text{
      position: absolute;
      top: 484px;
      right: 48px;
      font-size: 24px;
      color: #999;
    }
  }
}
</style>
